module.exports = __webpack_public_path__ + "img/hohlsaum_tiefschwarz_ral9005.eef86f3d.jpg";